import RegExp from '.RegExp';
import Infinity from '.Infinity';
import Object from '.Object';
import throwError from '.throw.Error';

import { Cf } from 'lib:unicode';

export var _Infinity = -Infinity;

export function NullLiteral ()         {
	return 'null';
}

export function BooleanLiteral (value         )                   {
	return value ? 'true' : 'false';
}

export var is                                                = Object.is || function is (value        ) { return value===0 && 1/value<0; };
export function NumericLiteral (value        )         {
	return value===Infinity || value===_Infinity || value!==value
		? /*#__PURE__*/ throwError('NumericLiteral('+value+')')
		: ( is(value, -0) ? '-' : '' )+value;
}

var CANT_IN_SINGLE_QUOTE = /[\n\r'\\\u2028\u2029]/g;
function staticallyEscape (cant_in_single_quote                              )         {
	return CHAR_TO_ESCAPED[cant_in_single_quote];
}

var CHAR_TO_ESCAPED = { '\n': '\\n', '\r': '\\r', '\'': '\\\'', '\\': '\\\\', '\u2028': '\\u2028', '\u2029': '\\u2029' };
function dynamicallyEscape (char_in_cf        )         {
	if ( char_in_cf.length>1 ) {
		return dynamicallyEscape(char_in_cf.charAt(0))+dynamicallyEscape(char_in_cf.charAt(1));
	}
	var hex         = char_in_cf.charCodeAt(0).toString(16).toUpperCase();
	switch ( hex.length ) {
		case 4:
			return '\\u'+hex;
		case 3:
			return '\\u0'+hex;
		case 2:
			return '\\x'+hex;
	}
	return '\\x0'+hex;
}

                                           

export function StringLiteral (value        )         {
	return '\''
		+value
		.replace(CANT_IN_SINGLE_QUOTE, staticallyEscape            )
		.replace(Cf, dynamicallyEscape            )
		+'\'';
}

var EOL = /\\[^\s\S]|[\n\r\/\u2028\u2029]/g;
function EOL_replacer (part        ) {
	switch ( part ) {
		case '\n':
		case '\\\n':
			return '\\n';
		case '\r':
		case '\\\r':
			return '\\r';
		case '/':
			return '\\/';
		case '\u2028':
		case '\\\u2028':
			return '\\u2028';
		case '\u2029':
		case '\\\u2029':
			return '\\u2029';
	}
	return part;
}
var AS_ES5 = ''+/*#__PURE__*/RegExp('')==='//' || ''+/*#__PURE__*/RegExp('/')==='///' || ''+/*#__PURE__*/RegExp('\n')==='/\n/'
	? function AS_ES5 (literal        ) {
		var index         = literal.length;
		while ( literal.charAt(--index)!=='/' ) { }
		var source         = literal.slice(1, index);
		source = source ? source.replace(EOL, EOL_replacer) : '(?:)';
		return '/'+source+literal.slice(index);
	}
	: function (literal        ) { return literal; };
var MAYBE_ES3 = /\/[gim]*$/;
var SLASH_NUL = /(?!^)\/(?![a-z]*$)|\x00|\\[\s\S]/g;
function SLASH_NUL_replacer (part        ) { return part==='\x00' ? '\\x00' : part==='/' ? '\\/' : part; }
export function RegularExpressionLiteral (value        )         {
	var literal         = AS_ES5(''+value);
	return MAYBE_ES3.test(literal)
		? literal.replace(Cf, dynamicallyEscape            ).replace(SLASH_NUL, SLASH_NUL_replacer)
		: literal;
}

export function BigIntLiteral (value        )         {
	return value+'n';
}
